import React, { useMemo, useReducer, useEffect, useCallback, useState } from 'react';
import { isEqual } from 'lodash-es';
import styles from "./MultiSelectFilterPicker.module.scss";
import { FilterPicker } from "../FilterPicker";
import { CheckboxWithLabel } from "./CheckboxWithLabel";
import { createReducer, getInitialSelection } from "./MultiSelectFilterPicker.reducer";
import { Searchbox } from "../Searchbox";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function MultiSelectFilterPicker(props) {
  const {
    label,
    options,
    title,
    removable,
    value,
    withSearchbox = false,
    startOpen = false,
    selectAllByDefault = true,
    ['data-testid']: testid,
    onChange,
    onRemove,
    onInputBlur,
    onInputFocus
  } = props;
  const [state, dispatchAction] = useReducer(createReducer(), getInitialSelection(selectAllByDefault, options.length));
  const [search, setSearch] = useState('');
  const trimmedLowercaseSearch = search.trim().toLowerCase();
  const isControlled = typeof value !== 'undefined';
  const getLabel = useCallback(selectedIndexes => {
    if (selectedIndexes.length > 1) {
      return "".concat(label, " (").concat(selectedIndexes.length, ")");
    } else if (selectedIndexes.length === 1) {
      return "".concat(label, " (").concat(options[selectedIndexes[0]].label, ")");
    } else {
      return label;
    }
  }, [options, label]);
  useEffect(() => {
    if (isControlled) {
      const indexes = [];
      const optionsList = [];
      if (value.length > 0) {
        options.forEach((optionObj, objIndex) => {
          if (value.indexOf(optionObj.value) > -1) {
            optionsList.push(optionObj);
            indexes.push(objIndex);
            return true;
          }
        });
      }
      dispatchAction({
        //todo - don't re-dispatch if already selected
        type: 'selectOptions',
        value: indexes
      });
      dispatchAction({
        type: 'applyChanges',
        label: getLabel(indexes)
      });
    }
  }, [value, options, isControlled, getLabel]);
  const allCount = useMemo(() => {
    return options.reduce((acc, _ref) => {
      let {
        counter
      } = _ref;
      return acc + (counter || 0);
    }, 0);
  }, [options]);
  return /*#__PURE__*/_jsx(FilterPicker, {
    startOpen: startOpen,
    "data-testid": testid,
    label: state.labelToDisplay || label,
    highlightTrigger: selectAllByDefault && !state.selectAll,
    title: title || label,
    removable: removable,
    headerContent: withSearchbox && /*#__PURE__*/_jsx(Searchbox, {
      className: styles.searchbox,
      "data-testid": testid && "".concat(testid, "-search"),
      value: search,
      onChange: e => setSearch(e.target.value),
      onClear: () => setSearch(''),
      onInputFocus: onInputFocus,
      onInputBlur: onInputBlur
    }),
    onRemove: onRemove,
    onApply: () => {
      if (!isEqual(state.previousState.selectedOptionsIndexes, state.selectedOptionsIndexes)) {
        const selectedOptionsIndexesArray = Array.from(state.selectedOptionsIndexes);
        if (!isControlled) {
          dispatchAction({
            type: 'applyChanges',
            label: getLabel(selectedOptionsIndexesArray)
          });
        }
        const selectedOptions = selectedOptionsIndexesArray.map(optionIndex => options[optionIndex].value);
        onChange(selectedOptions);
      }
    },
    onClose: opts => {
      if (opts !== null && opts !== void 0 && opts.revert) {
        dispatchAction({
          type: 'revert'
        });
      }
    },
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.checkboxGroup,
      children: [/*#__PURE__*/_jsx(CheckboxWithLabel, {
        id: "all",
        label: "Select all",
        sublabel: allCount ? "(".concat(allCount, ")") : null,
        testId: "".concat(testid, "-item-all"),
        checked: state.selectAll,
        onChange: () => dispatchAction({
          type: 'selectAll'
        })
      }), options.map((option, index) => (!trimmedLowercaseSearch || option.label.toLowerCase().includes(trimmedLowercaseSearch)) && /*#__PURE__*/_jsx(CheckboxWithLabel, {
        id: option.value,
        testId: "".concat(testid, "-item-").concat(option.value),
        label: option.label,
        sublabel: option.counter != null ? "(".concat(option.counter, ")") : null,
        checked: state.selectedOptionsIndexes.has(index),
        onChange: () => dispatchAction({
          type: 'selectOption',
          value: index
        })
      }, option.value))]
    })
  });
}